module.exports = "<ng-combo-date-picker\r\n        ng-order=\"{{options.templateOptions.order}}\"\r\n        class=\"comboDatePicker\"\r\n        ng-model=\"model[options.key]\"\r\n        ng-attrs-date='{ \"class\": \"day\" }'\r\n        ng-attrs-month='{ \"class\": \"month\" }'\r\n        ng-attrs-year='{ \"class\": \"year\"}'>\r\n</ng-combo-date-picker>";


//////////////////
// WEBPACK FOOTER
// ./static/js/app/layout/formly/types/combo-date-picker.html
// module id = 618
// module chunks = 1